import './SliderMedia.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import { Modal } from 'rsuite';

import Picture from '@/common/components/atoms/Picture/Picture';
import ButtonClose from '@/common/components/molecules/ButtonClose/ButtonClose';
import { SLIDER_MEDIA_FORMAT } from '@/common/constants';
import useFlags from '@/common/hooks/flags/useFlags';

import Flags from '../../atoms/Flags/Flags';
import Item from './Item/Item';
import ModalItem from './ModalItem/ModalItem';
import {
  SliderMediaDefaultProps,
  SliderMediaPropTypes,
} from './SliderMedia.proptypes';

const SliderMedia = ({
  className,
  bundleParents,
  flags,
  getImageAlt,
  getImageSrc,
  handleClickItem,
  handleCloseModal,
  id,
  isOpenModal,
  slider,
  sliderModalSettings,
  sliderSettings,
  stocks,
  tag,
}) => {
  const { t } = useTranslation();
  const { getFlags } = useFlags(flags, stocks);

  if (slider.length === 0) {
    return (
      <div
        className="slider-media__empty-placeholder"
        data-qa-id="slider-media-empty-placeholder"
      >
        {bundleParents?.length > 0 && (
          <div className="slider-media__bundle">
            {t('ebat:entities:product.details.bundle_parents.offer')}
          </div>
        )}
        <Picture src="" className="slider-media__image-placeholder" />
      </div>
    );
  }

  return (
    <>
      <Flags
        className="slider-media__flags"
        flags={getFlags}
        data-qa-id="flags"
      />
      {bundleParents?.length > 0 && (
        <div className="slider-media__bundle">
          {t('ebat:entities:product.details.bundle_parents.offer')}
        </div>
      )}
      <Slider
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...sliderSettings}
        className={cn('slider-media__wrapper', className)}
      >
        {slider.map((item, index) => (
          <Item
            alt={getImageAlt(item)}
            index={index}
            key={`media-${id}`}
            onClick={() => handleClickItem(index)}
            path={getImageSrc(item, SLIDER_MEDIA_FORMAT)}
            tag={tag}
            type={item.type}
          />
        ))}
      </Slider>
      <Modal
        className="slider-media-modal"
        full
        open={isOpenModal}
        onClose={handleCloseModal}
        data-qa-id="slider-media-modal"
      >
        <div className="slider-media-modal__close-wrapper">
          <ButtonClose
            className="slider-media-modal__close"
            onClick={handleCloseModal}
          />
        </div>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Slider {...sliderModalSettings} className="slider-media-modal__slider">
          {slider.map((item) => (
            <ModalItem
              key={`modal-media-${id}`}
              alt={getImageAlt(item)}
              className="slider-media-modal__item"
              path={getImageSrc(item, SLIDER_MEDIA_FORMAT)}
              type={item.type}
            />
          ))}
        </Slider>
      </Modal>
    </>
  );
};

SliderMedia.defaultProps = {
  ...SliderMediaDefaultProps,
};

SliderMedia.propTypes = {
  ...SliderMediaPropTypes,
};

export default SliderMedia;
